import React from "react";
import {
  AppContainer,
  AppMainContent,
  AppContent,
  NotificationContainer,
} from "@abb/abb-common-ux-react";

import notificationStore from "../../flux/stores/shared/NotificationStore";

import INotificationData from "../../models/shared/NotificationData";

import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";

interface ILoginLayoutState {
  notifications: any[];
  text: string;
  name: string;
  secondMsg: string;
  isLoading: boolean;
}

export default class LoginLayout extends React.Component<
  {},
  ILoginLayoutState
> {
  _mount: boolean;

  constructor(props: {}) {
    super(props);

    this._mount = false;
    this.state = {
      notifications: [],
      text: "",
      name: "",
      secondMsg: "",
      isLoading: true,
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    notificationStore.on(CONSTANTS.CHANGE_EVENT, (state: INotificationData) => {
      if (this._mount) {
        const notification = {
          type: "banner",
          severity: [state.severity],
          timeout: CONSTANTS.UI_NOTIFICATION_TIMEOUT,
          text: state.message,
        };
        const data = state.data;
        let name: string = "";
        let secondMsg: string = "";
        if (data !== undefined) {
          if (data.length > 0) {
            if (data.length === 1) {
              name = data[0];
            } else {
              name = data[0];
              secondMsg = data[1];
            }
          }
        }

        this.setState({
          notifications: this.state.notifications.concat(notification),
          text: state.message,
          name,
          secondMsg,
        });
      }
    });
  }

  public render() {
    return (
      <Translation>
        {(t) => (
          <AppContainer>
            <AppContent>
              <AppMainContent className="page-scroll">
                {this.props.children}
              </AppMainContent>
            </AppContent>
            <NotificationContainer
              notifications={this.state.notifications.filter(
                (x) =>
                (x.text = t(this.state.text, {
                  name: this.state.name,
                  secondmsg: this.state.secondMsg,
                }))
              )}
              actionHandler={{ remove: () => { } }}
              style={{
                top: '-5px',
                right: "0",
                zIndex: 10000,
                width: 490
              }}
            />
          </AppContainer>
        )}
      </Translation>
    );
  }
}
